import React, { Component } from 'react'
import DatePicker from 'react-datepicker';
import moment from "moment";
import 'react-datepicker/dist/react-datepicker.css';
import { Link } from 'react-router-dom'
import log from '../../../helpers/logger'
import { auth, getCurrentUser } from '../../../helpers/auth'
import { getTimeStamp, getUUIDV4 } from '../../../helpers/utils'
import {
  createIssue,
  updateIssue,
  getIssue,
  deleteIssue } from '../../../services/IssueService'

function setErrorMsg(error) {
  return {
    errorMsg: error.message
  }
}

export default class IssuePageEdit extends Component {

  constructor(props) {
    super(props);
    this.state = {

      issue_uuid: '',
      magazine_id: '',
      magazine_uuid: '',
      owner_id: '',
      tag: '',
      title: '',
      description: '',
      is_publish: '',
      issue_version: '',
      cover_width: '',
      cover_height: '',
      cover_url: '',
      issue_download_url: '',
      download_success_msg_title: '',
      download_success_msg_body: '',
      notify_cover_number: '',
      share_text: '',
      embed_html: '',
      date_released: '',
      date_modified: '',
      date_created: '',
      status: '',

      errorMsg: null,
      currentUser: null,
      isLoading: true
    };

    this.handleDateChange = this.handleDateChange.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);

  }

  componentWillMount() {
    log.debug('componentWillMount')
  }
  async componentDidMount(){
    log.debug('componentDidMount')
    let user = await getCurrentUser();
    this.setState({currentUser: user})

    // load info
    let issue = await getIssue(this.props.match.params.id)
    log.debug(issue)

    this.setState({issueId: this.props.match.params.id})
    this.setState({

      issue_uuid: issue.issue_uuid === undefined ? '' : issue.issue_uuid,
      magazine_id: issue.magazine_id === undefined ? '' : issue.magazine_id,
      magazine_uuid: issue.magazine_uuid === undefined ? '' : issue.magazine_uuid,
      owner_id: issue.owner_id === undefined ? '' : issue.owner_id,
      tag: issue.tag === undefined ? '' : issue.tag,
      title: issue.title === undefined ? '' : issue.title,
      description: issue.description === undefined ? '' : issue.description,
      is_publish: issue.is_publish === undefined ? '' : issue.is_publish,
      issue_version: issue.issue_version === undefined ? '' : issue.issue_version,
      cover_width: issue.cover_width === undefined ? '' : issue.cover_width,
      cover_height: issue.cover_height === undefined ? '' : issue.cover_height,
      cover_url: issue.cover_url === undefined ? '' : issue.cover_url,
      issue_download_url: issue.issue_download_url === undefined ? '' : issue.issue_download_url,
      download_success_msg_title: issue.download_success_msg_title === undefined ? '' : issue.download_success_msg_title,
      download_success_msg_body: issue.download_success_msg_body === undefined ? '' : issue.download_success_msg_body,
      notify_cover_number: issue.notify_cover_number === undefined ? '' : issue.notify_cover_number,
      share_text: issue.share_text === undefined ? '' : issue.share_text,
      embed_html: issue.embed_html === undefined ? '' : issue.embed_html,
      date_released: issue.date_released === undefined ? '' : issue.date_released,
      date_modified: issue.date_modified === undefined ? '' : issue.date_modified,
      date_created: issue.date_created === undefined ? '' : issue.date_created,
      status: issue.status === undefined ? '' : issue.status,

      })
    // setup for moment DatePicker
    this.setState({date_created: moment(issue.date_created)})

    log.debug(this.state)

    log.debug('all data is loaded.')
    this.setState({isLoading: false})
  }

  handleDateChange(date) {
    this.setState({
      date_created: date
    });
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    // bind all input to setState
    this.setState({
      [name]: value
    });
    log.debug(this.state)

  }

  async handleSubmit(event) {
    event.preventDefault();

    log.debug(this.state.date_created.toDate())

    // if you hace date.
    //date_created: this.state.date_created.toDate(),

    let issue = {

      issue_uuid: this.state.issue_uuid ,
      magazine_id: this.state.magazine_id ,
      magazine_uuid: this.state.magazine_uuid ,
      owner_id: this.state.owner_id ,
      tag: this.state.tag ,
      title: this.state.title ,
      description: this.state.description ,
      is_publish: this.state.is_publish ,
      issue_version: this.state.issue_version ,
      cover_width: this.state.cover_width ,
      cover_height: this.state.cover_height ,
      cover_url: this.state.cover_url ,
      issue_download_url: this.state.issue_download_url ,
      download_success_msg_title: this.state.download_success_msg_title ,
      download_success_msg_body: this.state.download_success_msg_body ,
      notify_cover_number: this.state.notify_cover_number ,
      share_text: this.state.share_text ,
      embed_html: this.state.embed_html ,
      date_released: this.state.date_released ,
      date_modified: this.state.date_modified ,
      date_created: this.state.date_created.toDate() ,
      status: this.state.status ,
    }
    log.debug(issue)

    try{
      let result = await updateIssue(this.state.issueId, issue)
      log.debug('update success')
      //redirect to view
      this.props.history.push(`/issue/view/${this.state.issueId}`)
    }catch (err) {
      log.debug(err)
      this.setState(setErrorMsg(err))
    }

  }

  render () {

    let content;

    if (this.state.isLoading) {
      content = <div>Loading...</div>;
    } else {
      content =
      <div>
        <h4 className="page-header">
          <Link to='/issue'>Issue</Link> -> &nbsp;
          <Link to={`/issue/view/${this.state.issueId}`}>{this.state.title}</Link>  ->&nbsp;
          Edit
        </h4>
        <form className="form-horizontal" role="form" onSubmit={this.handleSubmit}>

          {
            this.state.registerError &&
          <div className="form-group">
            <div className="col-sm-offset-2 col-sm-10">
              <div className="alert alert-danger" role="alert">
              <span className="sr-only">Error:</span>
              &nbsp;{this.state.registerError}
              </div>
            </div>
          </div>
          }


          <div className="form-group">
            <label htmlFor="issue_uuid" className="col-sm-2 control-label">issue_uuid:</label>
            <div className="col-sm-4">
              <input className="form-control"
                type="text"
                name="issue_uuid"
                value={this.state.issue_uuid}
                onChange={this.handleInputChange}
                placeholder="issue_uuid" readOnly/>
            </div>
          </div>
          <div className="form-group">
            <label htmlFor="magazine_id" className="col-sm-2 control-label">magazine_id:</label>
            <div className="col-sm-4">
              <input className="form-control"
                type="text"
                name="magazine_id"
                value={this.state.magazine_id}
                onChange={this.handleInputChange}
                placeholder="magazine_id" readOnly/>
            </div>
          </div>
          <div className="form-group">
            <label htmlFor="magazine_uuid" className="col-sm-2 control-label">magazine_uuid:</label>
            <div className="col-sm-4">
              <input className="form-control"
                type="text"
                name="magazine_uuid"
                value={this.state.magazine_uuid}
                onChange={this.handleInputChange}
                placeholder="magazine_uuid" />
            </div>
          </div>
          <div className="form-group">
            <label htmlFor="owner_id" className="col-sm-2 control-label">owner_id:</label>
            <div className="col-sm-4">
              <input className="form-control"
                type="text"
                name="owner_id"
                value={this.state.owner_id}
                onChange={this.handleInputChange}
                placeholder="owner_id" readOnly/>
            </div>
          </div>
          <div className="form-group">
            <label htmlFor="tag" className="col-sm-2 control-label">tag:</label>
            <div className="col-sm-4">
              <input className="form-control"
                type="text"
                name="tag"
                value={this.state.tag}
                onChange={this.handleInputChange}
                placeholder="tag"/>
            </div>
          </div>
          <div className="form-group">
            <label htmlFor="title" className="col-sm-2 control-label">title:</label>
            <div className="col-sm-4">
              <input className="form-control"
                type="text"
                name="title"
                value={this.state.title}
                onChange={this.handleInputChange}
                placeholder="title"/>
            </div>
          </div>
          <div className="form-group">
            <label htmlFor="description" className="col-sm-2 control-label">description:</label>
            <div className="col-sm-4">
              <input className="form-control"
                type="text"
                name="description"
                value={this.state.description}
                onChange={this.handleInputChange}
                placeholder="description"/>
            </div>
          </div>
          <div className="form-group">
            <label htmlFor="is_publish" className="col-sm-2 control-label">is_publish:</label>
            <div className="col-sm-4">
              <input className="form-control"
                type="text"
                name="is_publish"
                value={this.state.is_publish}
                onChange={this.handleInputChange}
                placeholder="is_publish"/>
            </div>
          </div>
          <div className="form-group">
            <label htmlFor="issue_version" className="col-sm-2 control-label">issue_version:</label>
            <div className="col-sm-4">
              <input className="form-control"
                type="text"
                name="issue_version"
                value={this.state.issue_version}
                onChange={this.handleInputChange}
                placeholder="issue_version"/>
            </div>
          </div>
          <div className="form-group">
            <label htmlFor="cover_width" className="col-sm-2 control-label">cover_width:</label>
            <div className="col-sm-4">
              <input className="form-control"
                type="text"
                name="cover_width"
                value={this.state.cover_width}
                onChange={this.handleInputChange}
                placeholder="cover_width"/>
            </div>
          </div>
          <div className="form-group">
            <label htmlFor="cover_height" className="col-sm-2 control-label">cover_height:</label>
            <div className="col-sm-4">
              <input className="form-control"
                type="text"
                name="cover_height"
                value={this.state.cover_height}
                onChange={this.handleInputChange}
                placeholder="cover_height"/>
            </div>
          </div>
          <div className="form-group">
            <label htmlFor="cover_url" className="col-sm-2 control-label">cover_url:</label>
            <div className="col-sm-4">
              <input className="form-control"
                type="text"
                name="cover_url"
                value={this.state.cover_url}
                onChange={this.handleInputChange}
                placeholder="cover_url"/>
            </div>
          </div>
          <div className="form-group">
            <label htmlFor="issue_download_url" className="col-sm-2 control-label">issue_download_url:</label>
            <div className="col-sm-4">
              <input className="form-control"
                type="text"
                name="issue_download_url"
                value={this.state.issue_download_url}
                onChange={this.handleInputChange}
                placeholder="issue_download_url"/>
            </div>
          </div>
          <div className="form-group">
            <label htmlFor="download_success_msg_title" className="col-sm-2 control-label">download_success_msg_title:</label>
            <div className="col-sm-4">
              <input className="form-control"
                type="text"
                name="download_success_msg_title"
                value={this.state.download_success_msg_title}
                onChange={this.handleInputChange}
                placeholder="download_success_msg_title"/>
            </div>
          </div>
          <div className="form-group">
            <label htmlFor="download_success_msg_body" className="col-sm-2 control-label">download_success_msg_body:</label>
            <div className="col-sm-4">
              <input className="form-control"
                type="text"
                name="download_success_msg_body"
                value={this.state.download_success_msg_body}
                onChange={this.handleInputChange}
                placeholder="download_success_msg_body"/>
            </div>
          </div>
          <div className="form-group">
            <label htmlFor="notify_cover_number" className="col-sm-2 control-label">notify_cover_number:</label>
            <div className="col-sm-4">
              <input className="form-control"
                type="text"
                name="notify_cover_number"
                value={this.state.notify_cover_number}
                onChange={this.handleInputChange}
                placeholder="notify_cover_number"/>
            </div>
          </div>
          <div className="form-group">
            <label htmlFor="share_text" className="col-sm-2 control-label">share_text:</label>
            <div className="col-sm-4">
              <input className="form-control"
                type="text"
                name="share_text"
                value={this.state.share_text}
                onChange={this.handleInputChange}
                placeholder="share_text"/>
            </div>
          </div>
          <div className="form-group">
            <label htmlFor="embed_html" className="col-sm-2 control-label">embed_html:</label>
            <div className="col-sm-4">
              <input className="form-control"
                type="text"
                name="embed_html"
                value={this.state.embed_html}
                onChange={this.handleInputChange}
                placeholder="embed_html"/>
            </div>
          </div>
          {/* <div className="form-group">
            <label htmlFor="date_released" className="col-sm-2 control-label">date_released:</label>
            <div className="col-sm-4">
              <input className="form-control"
                type="text"
                name="date_released"
                value={this.state.date_released}
                onChange={this.handleInputChange}
                placeholder="date_released"/>
            </div>
          </div>
          <div className="form-group">
            <label htmlFor="date_modified" className="col-sm-2 control-label">date_modified:</label>
            <div className="col-sm-4">
              <input className="form-control"
                type="text"
                name="date_modified"
                value={this.state.date_modified}
                onChange={this.handleInputChange}
                placeholder="date_modified"/>
            </div>
          </div> */}
          <div className="form-group">
            <label htmlFor="date_created" className="col-sm-2 control-label">date_created:</label>
            <div className="col-sm-4">
              <DatePicker
                className="form-control"
                type="text"
                name="date_created"
                selected={this.state.date_created}
                onChange={this.handleDateChange}
                // showTimeSelect
                dateFormat="DD/MM/YYYY h:mm"
              />
            </div>
          </div>
          <div className="form-group">
            <label htmlFor="status" className="col-sm-2 control-label">status:</label>
            <div className="col-sm-4">
              <input className="form-control"
                type="text"
                name="status"
                value={this.state.status}
                onChange={this.handleInputChange}
                placeholder="status"/>
            </div>
          </div>

          {/* <div className="form-group">
            <label htmlFor="date_created" className="col-sm-2 control-label">date_created:</label>
            <div className="col-sm-4">
              <DatePicker
                className="form-control"
                type="text"
                name="date_created"
                selected={this.state.date_created}
                onChange={this.handleDateChange}
                // showTimeSelect
                dateFormat="DD/MM/YYYY h:mm"
              />
            </div>
          </div> */}

          <div className="form-group">
            <div className="col-sm-offset-2 col-sm-10">
              <button type="submit" className="btn btn-primary">Edit</button>
            </div>
          </div>

        </form>
      </div>
    }


    return (
      <div>
          {content}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/IssuePage/IssuePageEdit.js